import { FieldTypes } from '../../../constants/FieldTypes'
import {
  DropdownField,
  DropdownOptionItem,
  Field,
  FieldMap,
  InfoStage,
} from '../../../types/forms/fields'
import { NoCoverageOption } from '../../../types/users/user'

export const noCoverageOptions: DropdownOptionItem<NoCoverageOption>[] = [
  { text: 'I want to pay out of pocket', id: 'out-of-pocket' },
  { text: 'I need advice on obtaining coverage', id: 'need-advice' },
]
export const noCoverageDescriptionField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Please specify...',
  condition: v => v?.option === 'no-coverage',
  options: noCoverageOptions,
}

export const noCoverageFields: Record<string, Field | InfoStage> = {
  noCoverageDescription: noCoverageDescriptionField,
}

export const noCoverageField: FieldMap = {
  name: '',
  children: noCoverageFields,
  condition: v => v?.option === 'no-coverage',
}
